// Ülkeler ve saat dilimleri
export const countries = [
  { code: 'TR', name: 'Türkiye', timezone: 'Europe/Istanbul' },
  { code: 'US', name: 'United States', timezone: 'America/New_York' },
  { code: 'GB', name: 'United Kingdom', timezone: 'Europe/London' },
  { code: 'DE', name: 'Germany', timezone: 'Europe/Berlin' },
  { code: 'FR', name: 'France', timezone: 'Europe/Paris' },
  { code: 'ES', name: 'Spain', timezone: 'Europe/Madrid' },
  { code: 'IT', name: 'Italy', timezone: 'Europe/Rome' },
  { code: 'NL', name: 'Netherlands', timezone: 'Europe/Amsterdam' },
  { code: 'BE', name: 'Belgium', timezone: 'Europe/Brussels' },
  { code: 'CH', name: 'Switzerland', timezone: 'Europe/Zurich' },
  { code: 'AT', name: 'Austria', timezone: 'Europe/Vienna' },
  { code: 'SE', name: 'Sweden', timezone: 'Europe/Stockholm' },
  { code: 'NO', name: 'Norway', timezone: 'Europe/Oslo' },
  { code: 'DK', name: 'Denmark', timezone: 'Europe/Copenhagen' },
  { code: 'FI', name: 'Finland', timezone: 'Europe/Helsinki' },
  { code: 'PL', name: 'Poland', timezone: 'Europe/Warsaw' },
  { code: 'CZ', name: 'Czech Republic', timezone: 'Europe/Prague' },
  { code: 'HU', name: 'Hungary', timezone: 'Europe/Budapest' },
  { code: 'RO', name: 'Romania', timezone: 'Europe/Bucharest' },
  { code: 'BG', name: 'Bulgaria', timezone: 'Europe/Sofia' },
  { code: 'GR', name: 'Greece', timezone: 'Europe/Athens' },
  { code: 'PT', name: 'Portugal', timezone: 'Europe/Lisbon' },
  { code: 'IE', name: 'Ireland', timezone: 'Europe/Dublin' },
  { code: 'HR', name: 'Croatia', timezone: 'Europe/Zagreb' },
  { code: 'SI', name: 'Slovenia', timezone: 'Europe/Ljubljana' },
  { code: 'SK', name: 'Slovakia', timezone: 'Europe/Bratislava' },
  { code: 'LT', name: 'Lithuania', timezone: 'Europe/Vilnius' },
  { code: 'LV', name: 'Latvia', timezone: 'Europe/Riga' },
  { code: 'EE', name: 'Estonia', timezone: 'Europe/Tallinn' },
  { code: 'CA', name: 'Canada', timezone: 'America/Toronto' },
  { code: 'MX', name: 'Mexico', timezone: 'America/Mexico_City' },
  { code: 'BR', name: 'Brazil', timezone: 'America/Sao_Paulo' },
  { code: 'AR', name: 'Argentina', timezone: 'America/Argentina/Buenos_Aires' },
  { code: 'CL', name: 'Chile', timezone: 'America/Santiago' },
  { code: 'CO', name: 'Colombia', timezone: 'America/Bogota' },
  { code: 'PE', name: 'Peru', timezone: 'America/Lima' },
  { code: 'VE', name: 'Venezuela', timezone: 'America/Caracas' },
  { code: 'EC', name: 'Ecuador', timezone: 'America/Guayaquil' },
  { code: 'UY', name: 'Uruguay', timezone: 'America/Montevideo' },
  { code: 'PY', name: 'Paraguay', timezone: 'America/Asuncion' },
  { code: 'BO', name: 'Bolivia', timezone: 'America/La_Paz' },
  { code: 'AU', name: 'Australia', timezone: 'Australia/Sydney' },
  { code: 'NZ', name: 'New Zealand', timezone: 'Pacific/Auckland' },
  { code: 'JP', name: 'Japan', timezone: 'Asia/Tokyo' },
  { code: 'CN', name: 'China', timezone: 'Asia/Shanghai' },
  { code: 'KR', name: 'South Korea', timezone: 'Asia/Seoul' },
  { code: 'IN', name: 'India', timezone: 'Asia/Kolkata' },
  { code: 'ID', name: 'Indonesia', timezone: 'Asia/Jakarta' },
  { code: 'TH', name: 'Thailand', timezone: 'Asia/Bangkok' },
  { code: 'VN', name: 'Vietnam', timezone: 'Asia/Ho_Chi_Minh' },
  { code: 'MY', name: 'Malaysia', timezone: 'Asia/Kuala_Lumpur' },
  { code: 'SG', name: 'Singapore', timezone: 'Asia/Singapore' },
  { code: 'PH', name: 'Philippines', timezone: 'Asia/Manila' },
  { code: 'ZA', name: 'South Africa', timezone: 'Africa/Johannesburg' },
  { code: 'EG', name: 'Egypt', timezone: 'Africa/Cairo' },
  { code: 'NG', name: 'Nigeria', timezone: 'Africa/Lagos' },
  { code: 'KE', name: 'Kenya', timezone: 'Africa/Nairobi' },
  { code: 'MA', name: 'Morocco', timezone: 'Africa/Casablanca' },
  { code: 'TN', name: 'Tunisia', timezone: 'Africa/Tunis' },
  { code: 'DZ', name: 'Algeria', timezone: 'Africa/Algiers' },
  { code: 'AE', name: 'UAE', timezone: 'Asia/Dubai' },
  { code: 'SA', name: 'Saudi Arabia', timezone: 'Asia/Riyadh' },
  { code: 'IL', name: 'Israel', timezone: 'Asia/Jerusalem' },
  { code: 'JO', name: 'Jordan', timezone: 'Asia/Amman' },
  { code: 'LB', name: 'Lebanon', timezone: 'Asia/Beirut' }
];

// Timezone'a göre ülke bulma
export function getCountryByCode(code) {
  return countries.find(c => c.code === code);
}

// Ülke koduna göre 12 saat formatı mı kullanılacağını belirle
export function uses12HourFormat(countryCode) {
  const countries12Hour = ['US', 'CA', 'AU', 'NZ', 'PH', 'IN', 'PK', 'BD', 'MY', 'SG'];
  return countries12Hour.includes(countryCode);
}

// Ülke koduna göre doğru locale belirleme
export function getLocaleByCountryCode(countryCode) {
  const localeMap = {
    'TR': 'tr-TR',
    'US': 'en-US',
    'GB': 'en-GB',
    'DE': 'de-DE',
    'FR': 'fr-FR',
    'ES': 'es-ES',
    'IT': 'it-IT',
    'NL': 'nl-NL',
    'BE': 'nl-BE',
    'CH': 'de-CH',
    'AT': 'de-AT',
    'SE': 'sv-SE',
    'NO': 'no-NO',
    'DK': 'da-DK',
    'FI': 'fi-FI',
    'PL': 'pl-PL',
    'CZ': 'cs-CZ',
    'HU': 'hu-HU',
    'RO': 'ro-RO',
    'BG': 'bg-BG',
    'GR': 'el-GR',
    'PT': 'pt-PT',
    'IE': 'en-IE',
    'HR': 'hr-HR',
    'SI': 'sl-SI',
    'SK': 'sk-SK',
    'LT': 'lt-LT',
    'LV': 'lv-LV',
    'EE': 'et-EE',
    'CA': 'en-CA',
    'MX': 'es-MX',
    'BR': 'pt-BR',
    'AR': 'es-AR',
    'CL': 'es-CL',
    'CO': 'es-CO',
    'PE': 'es-PE',
    'VE': 'es-VE',
    'EC': 'es-EC',
    'UY': 'es-UY',
    'PY': 'es-PY',
    'BO': 'es-BO',
    'AU': 'en-AU',
    'NZ': 'en-NZ',
    'JP': 'ja-JP',
    'CN': 'zh-CN',
    'KR': 'ko-KR',
    'IN': 'en-IN',
    'ID': 'id-ID',
    'TH': 'th-TH',
    'VN': 'vi-VN',
    'MY': 'ms-MY',
    'SG': 'en-SG',
    'PH': 'en-PH',
    'ZA': 'en-ZA',
    'EG': 'ar-EG',
    'NG': 'en-NG',
    'KE': 'en-KE',
    'MA': 'ar-MA',
    'TN': 'ar-TN',
    'DZ': 'ar-DZ',
    'AE': 'ar-AE',
    'SA': 'ar-SA',
    'IL': 'he-IL',
    'JO': 'ar-JO',
    'LB': 'ar-LB'
  };

  return localeMap[countryCode] || 'en-US';
}

// ✅ YENİ: Dil koduna göre locale belirleme (i18next language)
export function getLocaleByLanguage(languageCode) {
  const languageLocaleMap = {
    'tr': 'tr-TR',
    'en': 'en-US',
    'de': 'de-DE',
    'fr': 'fr-FR',
    'es': 'es-ES',
    'it': 'it-IT',
    'pt': 'pt-BR',
    'nl': 'nl-NL',
    'pl': 'pl-PL',
    'ru': 'ru-RU',
    'ja': 'ja-JP',
    'zh': 'zh-CN',
    'ko': 'ko-KR',
    'ar': 'ar-SA'
  };

  return languageLocaleMap[languageCode] || 'en-US';
}

// ✅ GELİŞMİŞ: Hem dil hem ülkeyi kullanarak tarihi formatla
export function formatDateForCountry(date, countryCode, options = {}, languageCode = null) {
  const country = getCountryByCode(countryCode);
  if (!country) return new Date(date).toLocaleString(); // fallback

  // Locale belirleme: Önce dil, sonra ülke
  let locale;
  if (languageCode) {
    locale = getLocaleByLanguage(languageCode);
  } else {
    locale = getLocaleByCountryCode(countryCode);
  }

  const use12Hour = uses12HourFormat(countryCode);

  const defaultOptions = {
    timeZone: country.timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',  // ✅ Saniye eklendi
    hour12: use12Hour,
    ...options
  };

  return new Date(date).toLocaleString(locale, defaultOptions);
}
